import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';
import { pillTone, type PillColor } from './pill-tone';

export type { PillColor };

interface PillChipProps {
  active: boolean;
  children: ReactNode;
  color?: PillColor | undefined;
  disabled?: boolean | undefined;
  onClick: () => void;
}

export const PillChip = ({ active, children, color, disabled, onClick }: PillChipProps) => (
  <button
    className={cn(
      'inline-flex min-h-6 items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium transition-shadow cursor-pointer',
      pillTone(active, color),
      disabled && 'pointer-events-none opacity-60',
    )}
    disabled={disabled}
    onClick={onClick}
    type="button"
  >
    {children}
  </button>
);
